import { render } from "./IosMain.vue?vue&type=template&id=f01d0a3c&scoped=true&ts=true"
import script from "./IosMain.vue?vue&type=script&lang=ts"
export * from "./IosMain.vue?vue&type=script&lang=ts"

import "./IosMain.vue?vue&type=style&index=0&id=f01d0a3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f01d0a3c"]])

export default __exports__